/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { ICardFieldProps } from "../cards/CardField"
import { defaultPrimitive, ILandingPrimitive, OrderContent } from "src/modules/pe-landing-module/data/interfaces"
import OrderPrimitive from "../../primitive/OrderPrimitive"

const CardFieldOrder = (props: ICardFieldProps): JSX.Element => {
    const { value, field, section, i, cardOrder, contentData } = props
    useEffect(() => { 
            addCSSClass(
                `landing-card-field-order-${section.id + "-" + value?.id}`,
                `.landing-card-field-order-${section.id + "-" + value?.id} {
                    
                } 
                `
            )
            return () => removeCSSClass(`landing-card-field-order-${section.id + "-" + value?.id}`)
        }, []) 
    
    const num = (cardOrder || 0) 

    const primitive: any = {
        ...defaultPrimitive(),
        ...field,
        ...value,  
        order: num,
        length: !!contentData && Array.isArray(contentData?.cards)  ? contentData.cards.length : 0,
        style: { ...field.style, ...value.style },
        className: (field.className || "") + " " + (value.style || "") + " medallion-padder",
        id: section.id + "-" + value?.id,
    } 

    return <div 
        className={`landing-card-field landing-card-field-order landing-card-field-order-${section.id + "-" + value.id} ${value.className}`}  
        style={{ ...field.style, ...value.style }}
        data-card-field-id={i} 
        card-field-section-id={section.id}
    >  
        <OrderPrimitive primitive={ primitive as any } />
        {/* { field.significant_zero ? num.toString().padStart(2, "0") : num }
        {
            field.is_show_full 
                ? 
                <>
                    <span className="opacity_5 px-1">
                        /
                    </span>
                    <span className="opacity_5 ">
                        { 
                            !!contentData && Array.isArray(contentData?.cards) 
                                ?
                                    field.significant_zero 
                                        ? 
                                        contentData.cards.length.toString().padStart(2, "0")
                                        :
                                        contentData.cards.length
                                :
                                null
                        }
                    </span>
                </>
                : 
                ""
        } */}
    </div>
}
export default CardFieldOrder